import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListDurationCell } from './emsp-bo-charging-session-list-duration.cell';
import { EmspBoChargingSessionListDurationHeader } from './emsp-bo-charging-session-list-duration.header';

export const EmspBoChargingSessionListDurationColumn: DisplayColumnDef<
  GatewayChargingSessionModel,
  unknown
> = {
  id: 'duration',
  enableSorting: false,
  header: EmspBoChargingSessionListDurationHeader,
  cell: EmspBoChargingSessionListDurationCell,
  meta: { maxWidth: '120px', width: '100px' },
};
